<div>
  <ngx-spinner type="ball-scale-multiple"
      template="<img src='../../resources/images/spinner-lnw.svg' width='60px' height='60px'/>"></ngx-spinner>
</div>
<router-outlet></router-outlet>
